@if (hasDocuments && hasImages) {
  <app-card-with-tabs
    [selectedTab]="selectedTab"
    [leftTabHeader]="'DocumentList.Pictures'|translate"
    [rightTabHeader]="'DocumentList.Documents'|translate"
    [hasHeader]="false"
    [hasFooter]="true"
  >
    <div leftTabContent class="h-full">
      <app-image-grid
        [pinnedImages]="pinnedImages"
        [notPinnedImages]="notPinnedImages"
        [pinnedTranslationKey]="pinnedTranslationKey"
        [pinLock]="pinLock"
        [deletePinnedLock]="deletePinnedLock"
        (onAddDocument)="openAddDocumentDialog($event)"
        (onPinDocument)="pinDocument($event)"
        (onUnpinDocument)="unpinDocument($event)"
        (onDeleteDocument)="openDeleteDocumentDialog($event)"
        (onViewDocument)="openViewDocumentDialog($event)"
        (onEditDocument)="openEditDocumentPage($event)"
      />
    </div>
    <div leftTabFooter class="flex justify-start">
      <button pButton pRipple label="{{'DocumentList.NewDocument'|translate}}" icon="pi pi-plus" size="large"
              (click)="openAddDocumentDialog('Image')"></button>
    </div>
    <div rightTabContent class="h-full">
      <app-document-list
        [pinnedDocuments]="pinnedDocuments"
        [notPinnedDocuments]="notPinnedDocuments"
        [pinnedTranslationKey]="pinnedTranslationKey"
        [pinLock]="pinLock"
        [deletePinnedLock]="deletePinnedLock"
        (onAddDocument)="openAddDocumentDialog($event)"
        (onPinDocument)="pinDocument($event)"
        (onUnpinDocument)="unpinDocument($event)"
        (onDeleteDocument)="openDeleteDocumentDialog($event)"
        (onViewDocument)="openViewDocumentDialog($event)"
        (onEditDocument)="openEditDocumentPage($event)"
      />
    </div>
    <div rightTabFooter class="flex justify-start">
      <button pButton pRipple label="{{'DocumentList.NewDocument'|translate}}" icon="pi pi-plus" size="large"
              (click)="openAddDocumentDialog('Document')"></button>
    </div>
  </app-card-with-tabs>
} @else {
  <app-card-with-header class="h-full"
    [usedWithTabs]="false"
    [hasHeader]="true"
    [hasFooter]="true"
  >
    <div header>
      @if(hasDocuments){
      {{ 'DocumentList.Documents'|translate }}
      } @else {
        {{ 'DocumentList.Pictures'|translate }}
      }
    </div>

    @if (hasImages) {
      <app-image-grid
        class="h-full"
        [pinnedImages]="pinnedImages"
        [notPinnedImages]="notPinnedImages"
        [pinnedTranslationKey]="pinnedTranslationKey"
        [pinLock]="pinLock"
        [deletePinnedLock]="deletePinnedLock"
        (onAddDocument)="openAddDocumentDialog($event)"
        (onPinDocument)="pinDocument($event)"
        (onUnpinDocument)="unpinDocument($event)"
        (onDeleteDocument)="openDeleteDocumentDialog($event)"
        (onViewDocument)="openViewDocumentDialog($event)"
        (onEditDocument)="openEditDocumentPage($event)"
      />
    } @else {
      <app-document-list
        class="h-full"
        [pinnedDocuments]="pinnedDocuments"
        [notPinnedDocuments]="notPinnedDocuments"
        [pinnedTranslationKey]="pinnedTranslationKey"
        [pinLock]="pinLock"
        [deletePinnedLock]="deletePinnedLock"
        (onAddDocument)="openAddDocumentDialog($event)"
        (onPinDocument)="pinDocument($event)"
        (onUnpinDocument)="unpinDocument($event)"
        (onDeleteDocument)="openDeleteDocumentDialog($event)"
        (onViewDocument)="openViewDocumentDialog($event)"
        (onEditDocument)="openEditDocumentPage($event)"
      />
    }
    <div footer class="flex justify-start">
      @if(hasDocuments){
        <button pButton pRipple label="{{'DocumentList.NewDocument'|translate}}" icon="pi pi-plus" size="large"
                (click)="openAddDocumentDialog('Document')"></button>
      } @else {
        <button pButton pRipple label="{{'DocumentList.NewDocument'|translate}}" icon="pi pi-plus" size="large"
                (click)="openAddDocumentDialog('Image')"></button>
      }
    </div>
  </app-card-with-header>
}
